import {AppConfig} from 'appConfig';
import {formatDateTimeSeconds} from '../../common/formatters';

export const getBuildInfoText = (appConfig: AppConfig): string => {
    const buildInfo = appConfig.buildInfo;

    return [
        `Env: ${appConfig.env}`,
        buildInfo?.vcs?.shortHash && `Revision: ${buildInfo.vcs.shortHash}`,
        buildInfo?.datetime && `Build: ${formatDateTimeSeconds(buildInfo.datetime)}`
    ]
        .filter(Boolean)
        .join('\r\n');
};
